// extracted by mini-css-extract-plugin
var _1 = "PopupContent_limitedWidth__ytqTD";
var _2 = "PopupContent_minContent__kMm5-";
var _3 = "PopupContent_wrapper__Gp-GI";
export { _1 as "limitedWidth", _2 as "minContent", _3 as "wrapper" }
